import { render, staticRenderFns } from "./FieldWorkplaceList.vue?vue&type=template&id=b3d63b74&scoped=true&"
import script from "./FieldWorkplaceList.vue?vue&type=script&lang=js&"
export * from "./FieldWorkplaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d63b74",
  null
  
)

export default component.exports